import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ModalController, NavController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import * as countryCodes from 'country-codes-list'
import { isValidPhoneNumber } from 'libphonenumber-js';
import * as countries from 'i18n-iso-countries';
import en from "i18n-iso-countries/langs/en.json"; // Import JSON directly
import { TranslateService } from './translate.service';
import { plainToInstance } from 'class-transformer';
import { validate } from 'class-validator';
import Swal from 'sweetalert2'
import { firstValueFrom, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { accountingUrl, androidVersion, baseUrl, einvoiceUrl, iosVersion, myInvoisPortalUrl, websiteVersion } from 'src/environments/environment';
import imageCompression from 'browser-image-compression';
import * as XLSX from 'xlsx';
import { SafariViewController } from '@awesome-cordova-plugins/safari-view-controller/ngx';
import mime from 'mime';
import _ from 'lodash';
import { ConfirmPage } from '../modals/confirm/confirm.page';
countries.registerLocale(en);
import { EmailComposer } from 'capacitor-email-composer'
import { Clipboard } from '@capacitor/clipboard';
import { Browser } from '@capacitor/browser';
import { ConfirmButton } from '../models/confirm-button.model';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import write_blob from "capacitor-blob-writer";
import { IncorpProgressPage } from '../modals/incorp-progress/incorp-progress.page';
import { jwtDecode } from 'jwt-decode';
import * as QRCode from 'qrcode';
import { CompanyListComponent } from '../popover/company-list/company-list.component';
import { BundleInfo, CapacitorUpdater } from '@capgo/capacitor-updater';
import { InappupdatePage } from '../modals/inappupdate/inappupdate.page';
import { UpdatePage } from '../modals/update/update.page';
import { ConfirmInputPage } from '../modals/confirm-input/confirm-input.page';
import { StateService } from './state.service';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  public loadingUser = true
  public loadingCompanyList = true
  public loadingTask = true
  public loadingRequest = true
  public loadingNotifications = true
  public loadingTaskDetails = true
  public loadingRequestDetails = true
  public loadingInvoices = true
  public loadingCompantDetails = true
  public loadingResolutionDetails = true
  public loadingResolutionList = true
  public loadingDocuments = true
  public loadingCosecDetails = true
  public loadingTaskList = true
  public isCompanylistExists = false
  public isApplicationSubmitted = null
  public loadingInvitations = false
  public loadingShopServices = false
  public currentVersion = ''
  public inAppVersion = ''
  public showImageNotification = {
    show: false,
    image: '',
    notificationId: ''
  }


  public inAppVersionData = {}
  inAppUpdateModal = null
  public currentDomain = this.getDomain()

  public number2DigitsIMask = {
    mask: Number,
    scale: 2,
    thousandsSeparator: ',', // thousand separator
    radix: '.',           // decimal separator
    mapToRadix: ['.']     // allow dot as decimal
  }

  public numberIMask = {
    mask: Number,
    scale: 0,
    thousandsSeparator: ',', // thousand separator
    radix: '.',           // decimal separator
    mapToRadix: ['.']     // allow dot as decimal
  }

  public nricMask = {
    mask: '000000-00-0000'
  };

  private stateService?: StateService;

  constructor(
    private nav: NavController,
    private http: HttpClient,
    private translateService: TranslateService,
    private safariViewCtrl: SafariViewController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private popoverCtrl: PopoverController,
    private injector: Injector,
    private nzModalService: NzModalService
  ) {
    this.currentVersion = this.isNativePlatform() ? (this.platform.is('ios') ? iosVersion : androidVersion) : websiteVersion
  }

  private getStateService(): StateService {
    if (!this.stateService) {
      this.stateService = this.injector.get(StateService);
    }
    return this.stateService;
  }



  validateInput(data: Record<string, any>, className, rules: string[]) {

    const processValidationErrors = (error: any) => {
      if (error.children.length === 0) {
        return {
          status: 'error',
          error_message: Object.values(error.constraints)[0],
        };
      } else {
        return error.children.reduce((acc, childError) => {
          acc[childError.property] = processValidationErrors(childError); // Recursive call
          return acc;
        }, {});
      }
    };

    return new Promise((resolve) => {
      data = plainToInstance(className, data); // Transform the plain object to an instance

      console.log(data)
      validate(data).then(errors => {

        let validatorResult = {}

        if (rules.length != 0)
          errors = errors.filter(g => rules.includes(g['property']))

        if (errors.length > 0) {
          errors.forEach((error) => {
            validatorResult[error.property] ??= processValidationErrors(error); // Use the recursive function
          });

          resolve({ status: 'FAIL', result: validatorResult, message: Object.values(validatorResult)[0]['error_message'] });

        } else {
          validatorResult = {};

          resolve({ status: 'SUCCESS', result: {}, correctData: data });
        }
      });
    })


  }

  getCountryState() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/data/malaysia_states.json').subscribe((res) => {
        resolve(res)
      })
    })
  }

  getMalaysiaBusinessCode() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/data/business_codes.json').subscribe((res) => {
        resolve(res)
      })
    })
  }

  getSingaporeBusinessCode() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/data/business_codes_singapore.json').subscribe((res) => {
        resolve(res)
      })
    })
  }

  getAddressRules() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/data/address_rules.json').subscribe((res) => {
        resolve(res)
      })
    })
  }

  isNativePlatform() {
    return Capacitor.isNativePlatform()
  }

  isNativeAndroid() {
    return Capacitor.isNativePlatform() && this.platform.is('android')
  }

  isNativeiOS() {
    return Capacitor.isNativePlatform() && this.platform.is('ios')
  }

  isMobileWeb() {
    return this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios'))
  }

  isMobileWebiOS() {
    return this.platform.is('mobileweb') && this.platform.is('ios')
  }

  isMobileWebAndroid() {
    return this.platform.is('mobileweb') && this.platform.is('android')
  }

  getAllCountries() {
    return countryCodes.customArray({ countryCallingCode: '+{countryCallingCode}', countryName: '{countryNameEn}', countryCode: '{countryCode}', flag: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{countryCode}.svg' }).map(f => ({ ...f, flag: f['flag'] }));
  }

  navigateRoot(page) {
    this.nav.navigateRoot(page)
  }

  async generalPartnerLink(page, applicationId, uid = '', message = '') {

    console.log(123)

    console.log()

    if (this.getStateService().userInfo && this.getStateService().userInfo['partner_info']?.['done'] !== true) {
      this.showToast('This function is temporarily unavailable while we\'re setting up the website. Please check back soon.', 'error', 'bottom')
      return
    }

    let partnerLinkChecker = await firstValueFrom(
      this.http.get(`${baseUrl}/create-partner-link?path=${page}&applicationId=${applicationId}&uid=${uid}`)
    );


    if (partnerLinkChecker['status'] === 'SUCCESS') {
      await Clipboard.write({
        string: message + partnerLinkChecker['link']
      });


      this.showToast('Copied to clipboard!', 'message', 'bottom')
    }


  }




  navigateToPage(page) {
    this.nav.navigateForward(page, {
      animated: this.isNativePlatform() ? true : true
    })
  }

  convertToNumber(x) {
    return x ? Number(x.toString().replace('RM', '').replace(/[,]/g, '').trim()) : 0
  }

  formatWithCommas(value: any) {
    if (typeof value === 'number') {
      return value.toLocaleString('en-US');
    } else if (typeof value === 'string' && !isNaN(value as any)) {
      return parseFloat(value).toLocaleString('en-US');
    }

    throw new Error("Invalid input: value must be a number or numeric string");
  }

  showMessage(title, description, icon) {
    return Swal.fire({
      title: title,
      text: description,
      icon: icon,
      showCancelButton: false,
      timerProgressBar: false,
      // timer: 5000,
    })
  }

  isNullOrEmpty(...args: any[]) {
    let temp = args[0];

    if (temp === undefined || temp === null || temp === '') {
      return true;
    }

    else if (typeof temp === 'string') {
      if (temp === undefined || temp === null || (temp || '').trim() === '') {
        return true;
      }

      return false;
    }

    else if (typeof temp === 'object') {
      let variable = args[1];

      for (let i = 0; i < variable.length; i++) {
        if (
          temp[variable[i]] === undefined ||
          temp[variable[i]] === null ||
          (temp[variable[i]] || '').trim() === ''
        ) {
          return true;
        }
      }

      return false;
    }

    return true
  }

  async openCamera(type) {

    return new Promise((resolve, reject) => {

      Camera.getPhoto({
        quality: 50,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: type == 'all' ? CameraSource.Prompt : type == 'camera' ? CameraSource.Camera : CameraSource.Photos,
        promptLabelHeader: this.translateService.translate('Upload Photo'),
        promptLabelPicture: this.translateService.translate('Camera'),
        promptLabelPhoto: this.translateService.translate('Select from Photo Library'),
        promptLabelCancel: this.translateService.translate('Cancel')
      }).then((image) => {

        resolve('data:image/jpeg;base64,' + image.base64String)

      }).catch(async (error) => {

        reject(error)

      })
    })
  }


  async copyToClipboard(value) {
    await Clipboard.write({
      string: value
    });

    this.showToast('Copied to clipboard!', 'message', 'bottom')

    return true;
  }

  pleaseWait(title, text) {
    const translatedTitle = typeof title === 'object' && title?.key
      ? this.translateService.translate(title.key, title.params || {})
      : this.translateService.translate(String(title ?? ''));
    const translatedText = typeof text === 'object' && text?.key
      ? this.translateService.translate(text.key, text.params || {})
      : this.translateService.translate(String(text ?? ''));
    Swal.fire({
      title: translatedTitle,
      text: translatedText,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Start the loading spinner
      }
    });
  }

  swalClose() {
    Swal.close()
  }

  uploadFileFromLocal() {

    return new Promise((resolve) => {

      if (this.isNativePlatform()) {
        Camera.getPhoto({
          quality: 50,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Photos
        }).then((image) => {

          resolve('data:image/jpeg;base64,' + image.base64String)

        }).catch(async (error) => {

          // reject(error)

        })
      } else {

      }


    })

  }

  base64ToLink(folder, base64) {
    return new Promise((resolve, reject) => {
      if (base64 != null && base64 != undefined && base64 != '') {

        if (base64.startsWith('https://')) {
          resolve({ success: true, link: base64 })
          return
        }

        let splitArr = base64.replace(';base64,', "thisisathingtoreplace;").split("thisisathingtoreplace;")

        const type = splitArr[0].split(';')[0].split('/')[1];

        let documentExtension = splitArr[0].split(';')[0].split('/')[0] == 'data:image' ? type : 'pdf'

        const randomKey = Date.now().toString(36).substring(0, 5) + Math.random().toString(36).substr(2).substring(0, 4) + '.' + documentExtension

        this.http.post(baseUrl + '/uploadBaseToSG', { base64: splitArr[1], fileName: randomKey, contentType: (splitArr[0].split(';')[0].split('/')[0] == 'data:image' ? `image/${type}` : 'application/pdf') }, {}).subscribe((res) => {
          resolve({ success: true, link: res['Location'] })
          return
        })


      }
    })
  }

  uploadFileToUrl(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const uploadReq = new HttpRequest('POST', `${baseUrl}/upload-file`, formData, {
      headers: new HttpHeaders(),
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(uploadReq);
  }


  convertBase64ToFile(base64: string, fileName: string): Promise<File> {

    return new Promise(async (resolve) => {
      const mimeType = base64.split(';')[0].split(':')[1];
      const base64Data = base64.split(',')[1];

      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
      }

      const blob = new Blob(byteArrays, { type: mimeType });

      const options = {
        maxSizeMB: 5,      // Target size in MB
        maxWidthOrHeight: 800, // Maximum width/height (resize)
        useWebWorker: true,  // Use WebWorker for better performance
      };

      let file = new File([blob], `${fileName}.${mime.getExtension(mimeType)}`, { type: mimeType });

      const compressedFile = mimeType.startsWith('image') ? await imageCompression(file, options) : file
      resolve(compressedFile)
    })
  }


  async isCameraAllowed() {
    return new Promise(async resolve => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        stream.getTracks().forEach(track => track.stop());
        resolve(true)
      } catch (error) {
        resolve(false)
      }
    })
  }

  cleanObject(input: any, propertiesToClean: string[], keysToKeep: any): any {
    const updatedObject = { ...input };

    propertiesToClean.forEach((prop) => {
      if (updatedObject[prop]) {
        // Use Lodash's _.pick to keep only the specified keys for the property
        updatedObject[prop] = _.pick(updatedObject[prop], keysToKeep.map(String));  // Convert keys to strings
      }
    });

    return updatedObject;
  }

  openUrl(url) {
    this.safariViewCtrl.isAvailable().then(async (available: boolean) => {
      if (available) {
        this.safariViewCtrl.show({ url: url, }).subscribe((result: any) => {
          if (result.event === 'opened') console.log('Opened');
          else if (result.event === 'loaded') console.log('Loaded');
          else if (result.event === 'closed') console.log('Closed');
        }, (error: any) => {
          console.error(error)
        });

      } else {
        window.open(url, '_system');
      }
    }).catch(async (error) => {
      window.open(url, '_system');
    });;
  }

  private yearEndPromptOpen = false;

  /**
   * For the /getFinancialYearEnd call on a report page: asks the user to set the
   * financial year end when the company has none (no value, or no organisation
   * row at all). The report still drafts, on a December year end.
   */
  promptIfYearEndNotSet<T>() {
    return (source: Observable<T>) => source.pipe(tap({
      next: (response: any) => { if (!response?.UF_CRM_1581839855748) this.promptYearEndNotSet(); },
      error: (error: any) => { if (error?.status === 404) this.promptYearEndNotSet(); }
    }));
  }

  private promptYearEndNotSet() {
    if (this.yearEndPromptOpen) return;
    this.yearEndPromptOpen = true;
    this.showConfirmButton({
      title: 'Financial year end not set',
      description: 'Reports use a December year end until you set it.',
      confirmText: 'Open Settings',
      cancelText: 'Not now'
    } as ConfirmButton).then((answer) => {
      this.yearEndPromptOpen = false;
      if (answer === 'Confirm') this.navigateToPage('accounting/setting');
    });
  }

  showConfirmButton(options: ConfirmButton): Promise<'Confirm' | 'Cancel' | any> {
    return new Promise((resolve) => {
      this.nzModalService.confirm({
        nzTitle: options.title || 'Confirmation',
        nzContent: options.description,
        nzOkText: options.confirmText || 'Confirm',
        nzCancelText: options.showCancelButton === false ? null : options.cancelText || 'Cancel',
        nzClosable: options.hideCloseButton !== true,
        // Optional, so every existing caller keeps ant's default question icon.
        ...(options.iconType ? { nzIconType: options.iconType } : {}),
        ...(options.className ? { nzClassName: options.className } : {}),
        nzOnOk: () => {
          if (options.isNotification === true) {
            this.http.post(baseUrl + '/notifications/read', {
              id: options.notificationId
            }).subscribe();

            this.getStateService().readNotifications(options.notificationId);

            setTimeout(() => {
              this.checkPopUpNotification();
            }, 1000);
          }
          resolve('Confirm');
        },
        nzOnCancel: () => {
          resolve('Cancel');
        }
      });
    });
  }

  async readImageNotification() {
    this.http.post(baseUrl + '/notifications/read', {
      id: this.showImageNotification.notificationId
    }).subscribe()

    this.showImageNotification.show = false
    this.showImageNotification.image = ''
    this.showImageNotification.notificationId = ''

    this.getStateService().readNotifications(this.showImageNotification.notificationId)

    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 1000);
    })

    this.checkPopUpNotification()
  }

  checkPopUpNotification() {
    let popUpNotification = this.getStateService().notificationList.filter(x => (x['click_action'] === 'popup' || x['click_action'] === 'image') && x['is_read'] === 0)
    if (popUpNotification.length > 0) {
      if (popUpNotification[0]['click_action'] === 'popup') {
        const notif = popUpNotification[0]
        const navigateTo = notif['url'] || notif['data']?.['url'] || ''
        const popupTitle = notif['title'] || notif['data']?.['title'] || ''
        const confirmText = navigateTo ? 'Proceed' : 'Okay'
        const showCancel = !!navigateTo
        this.showConfirmButton({
          isNotification: true,
          notificationId: notif['id'],
          title: popupTitle,
          confirmText: confirmText,
          description: notif['data']?.['innerHtml'] || notif['message'] || '',
          showCancelButton: showCancel,
          cancelText: 'Later'
        }).then((result) => {
          if (navigateTo && result === 'Confirm') {
            this.navigateToPage(navigateTo)
          }
        })
      }
      else {
        this.showImageNotification.show = true
        this.showImageNotification.image = popUpNotification[0]['picture_url']
        this.showImageNotification.notificationId = popUpNotification[0]['id']
      }

    }

  }

  showConfirmInputButton(options: ConfirmButton) {
    return new Promise(async (resolve) => {
      // Ensure no SweetAlert overlay is blocking interactions
      try {
        if ((Swal as any)?.isVisible?.()) {
          Swal.close();
          await new Promise(r => setTimeout(r, 200));
        }
      } catch { /* noop */ }

      const modal = await this.modalCtrl.create({
        cssClass: 'my-custom-class',
        component: ConfirmInputPage,
        backdropDismiss: false,
        componentProps: options
      });

      await modal.present();

      const data = await modal.onWillDismiss();

      resolve(data.data)
    })
  }

  async openEmail(email, subject, body) {

    if (this.isNativePlatform()) {
      EmailComposer.open({
        'to': email,
        'subject': subject,
        'body': body
      })

    } else {
      await Browser.open({ url: `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` });
    }

  }

  async callNumber(phone_number) {
    await Browser.open({ url: `tel:${phone_number}` });
  }

  fileChange(event) {
    return new Promise((resolve, reject) => {
      if (event.target.files && event.target.files[0] && event.target.files[0].size < (10485768)) {

        const file = event.target.files[0];
        let extension = event.target.files[0].type
        if (extension == 'application/pdf') {

          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result.toString().replace(';base64,', "thisisathingtoreplace;")
            let imgarr = base64String.split("thisisathingtoreplace;")
            event.target.value = ''

            resolve({ success: true, data: { image: reader.result.toString(), files: file, base64String: imgarr[1] } })
          };

          reader.readAsDataURL(file);

        } else {
          var canvas = <HTMLCanvasElement>document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          var maxW = 400;
          var maxH = 400;
          var img = new Image;
          img.onload = () => {
            var iw = img.width;
            var ih = img.height;
            var scale = Math.min((maxW / iw), (maxH / ih));
            var iwScaled = iw * scale;
            var ihScaled = ih * scale;
            canvas.width = iwScaled;
            canvas.height = ihScaled;
            ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
            event.target.value = ''


            let imagec = canvas.toDataURL();
            let imgggg = imagec.replace(';base64,', "thisisathingtoreplace;")
            let imgarr = imgggg.split("thisisathingtoreplace;")
            let base64String = imgarr[1]

            resolve({ success: true, data: { image: imagec, files: file, base64String: base64String } })
          };

          img.src = URL.createObjectURL(file);
        }



        // var canvas = <HTMLCanvasElement>document.createElement("canvas");
        // var ctx = canvas.getContext("2d");
        // var cw = canvas.width;
        // var ch = canvas.height;
        // var maxW = 400;
        // var maxH = 400;
        // var type = event.target.files[0].type;
        // var file = event.target.files[0]
        // var img = new Image;
        // img.onload = () => {
        //   var iw = img.width;
        //   var ih = img.height;
        //   var scale = Math.min((maxW / iw), (maxH / ih));
        //   var iwScaled = iw * scale;
        //   var ihScaled = ih * scale;
        //   canvas.width = iwScaled;
        //   canvas.height = ihScaled;
        //   ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        //   event.target.value = ''


        //   let imagec = canvas.toDataURL();
        //   let imgggg = imagec.replace(';base64,', "thisisathingtoreplace;")
        //   let imgarr = imgggg.split("thisisathingtoreplace;")
        //   let base64String = imgarr[1]

        //   resolve({ success: true, data: { image: imagec, files: file, base64String: base64String } })
        // }

        // img.src = URL.createObjectURL(event.target.files[0]);

      } else {
        reject({ success: false, message: '"Your Current Image Too Large, " + event.target.files[0].size / (10241024) + "MB! (Please choose file lesser than 8MB)"' })
        alert("Your Current Image Too Large, " + event.target.files[0].size / (10241024) + "MB! (Please choose file lesser than 8MB)")
      }
    })
  }

  phoneValidater(phone) {
    return isValidPhoneNumber(phone)
  }

  emailValidator(email) {
    if (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    } else {
      return false;
    }
  }
  isValidJson(x) {
    try {
      JSON.parse(JSON.stringify(x));
      return true;
    } catch (e) {
      return false;
    }
  }


  async downloadPdf(link, fileName) {
    try {
      if (this.isNativePlatform()) {
        let downloadResult = await Filesystem.downloadFile({
          progress: true,
          recursive: true,
          directory: Directory.Data,
          path: fileName,
          url: link
        })

        const fileOpenerOptions: FileOpenerOptions = {
          filePath: downloadResult['path'],
          openWithDefault: true,
        };

        await FileOpener.open(fileOpenerOptions);
      } else {
        window.open(link)
      }

    } catch (error) {
      console.error("Error saving file:", error);
    }
  }

  // Downloads an AI-generated image (logo / business card) without navigating the app away.
  // Stored images go through the backend so they arrive as an attachment; base64 images are saved directly.
  async downloadGeneratedImage(image: string, fileName: string) {
    if (!image) return

    if (image.startsWith('data:')) {
      await this.writeFile(image.split(',')[1] || '', 'image/png', fileName)
      return
    }

    const downloadUrl = `${baseUrl}/generated-image-download?url=${encodeURIComponent(image)}&filename=${encodeURIComponent(fileName)}`

    if (this.isNativePlatform()) {
      await this.downloadPdf(downloadUrl, fileName)
    } else {
      window.open(downloadUrl, '_blank')
    }
  }

  async writeFile(base64File, contentType, fileName) {
    try {

      let blobFile = this.base64ToBlob(base64File, contentType)

      if (this.isNativePlatform()) {
        let writeFileResult = await write_blob({
          path: fileName,
          directory: Directory.Data,
          blob: blobFile,
          recursive: true,
        });

        const fileOpenerOptions: FileOpenerOptions = {
          filePath: writeFileResult.replace('file://', ''),
          openWithDefault: true,
        };

        await FileOpener.open(fileOpenerOptions);

      } else {
        const url = URL.createObjectURL(blobFile);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }



    } catch (error) {
      console.error("Error saving file:", error);
    }
  }

  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = new Array(slice.length);
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  }

  getDomain(path = window.location.host): string {
    const host = path;
    const parts = host.split('.');

    if (parts.length > 2) {
      return parts.slice(-2).join('.');
    }

    return host;
  }

  navigateBack(page) {
    // this.nav.pop()
    // this.ionRouter.canGoBack() ? this.nav.pop() : this.nav.navigateRoot(page)
  }

  /**
   * Money for a report cell — '1,234.56', and '0.00' for anything that is not a
   * number.
   *
   * Byte-identical copies of this already live in account-transaction,
   * fixed-asset-report, journal-report and trial-balance. New report pages should
   * call this one instead of adding a fifth. (The existing four are deliberately
   * left alone — moving them is a separate, low-value change.)
   */
  formatReportAmount(value: number | null | undefined): string {
    if (value === null || value === undefined || typeof value !== 'number') {
      return '0.00';
    }
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /**
   * Turn a report's PDF title into a safe download file name.
   *
   * Every accounting report already sets a good `info.title` on its
   * docDefinition, but that only names the browser TAB. pdfMake's .open() hands
   * the viewer a `blob:` URL whose path is a GUID, so saving from that tab gives
   * the user "unknown.pdf". Passing a real name to .download() is what actually
   * names the file, and deriving it from the same title keeps the file name and
   * the document metadata in step.
   *
   *   'Trial Balance - Acme Sdn Bhd (2026-03-31)'
   *     -> 'Trial_Balance_Acme_Sdn_Bhd_2026-03-31.pdf'
   */
  reportFileName(title: string): string {
    const cleaned = String(title || 'Report')
      // Windows forbids \ / : * ? " < > | in a file name; the rest are dropped
      // because they survive a download but make the file awkward to handle.
      .replace(/[\\/:*?"<>|]/g, ' ')
      .replace(/[()\[\]{}]/g, ' ')
      // Only a hyphen used as a SEPARATOR (spaces both sides). A bare \s*-\s*
      // would also eat the hyphens inside 2026-03-31.
      .replace(/\s+-\s+/g, ' ')
      .trim()
      .replace(/\s+/g, '_');
    // Some filesystems cap a name at 255 bytes; leave room for the extension.
    const trimmed = (cleaned || 'Report').slice(0, 200);
    return `${trimmed}.pdf`;
  }

  /**
   * Scrape a rendered table into an .xlsx download.
   *
   * Seven report pages repeat this same six-line shape, differing only in the
   * element id, sheet name and file name. Returns false when the element is not in
   * the DOM so the caller can tell the user rather than failing silently.
   *
   * NOT for reports that build their own sheet (balance-sheet, profit-and-loss,
   * manual-journal) — those have real per-report layout logic.
   */
  exportTableToXlsx(tableId: string, sheetName: string, fileName: string): boolean {
    const table = document.getElementById(tableId);
    if (!table) {
      console.error(`exportTableToXlsx: table element "${tableId}" not found`);
      return false;
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const workbook: XLSX.WorkBook = {
      Sheets: { [sheetName]: worksheet },
      SheetNames: [sheetName]
    };
    XLSX.writeFile(workbook, fileName);
    return true;
  }

  roundToTwo(num: number): number {
    if (num === null || num === undefined || isNaN(num)) return 0;
    return +(Math.round(Number(num + "e+2")) + "e-2");
  }

  async showProgressBar() {
    const modal = await this.modalCtrl.create({
      cssClass: 'modalTransparent',
      component: IncorpProgressPage,
      backdropDismiss: true
    });

    modal.present()
  }


  async showCompanyList(e: Event) {
    let decodedPayload = jwtDecode(localStorage.getItem('ALTOMATE_ACCESS_TOKEN_KEY'))
    let currentEmail = decodedPayload['email']

    const popover = await this.popoverCtrl.create({
      component: ['eng@cwc-co.com.my', 'support@altomate.io'].includes(currentEmail) ? CompanyListComponent : CompanyListComponent,
      event: e,
      side: 'bottom',
      alignment: 'center',
      cssClass: 'popover-company-list',
    });


    await popover.present();
    await popover.onWillDismiss();
  }


  checkVersioning() {
    let version = this.platform.is('android') ? androidVersion : iosVersion
    let type = this.platform.is('android') ? 'android' : 'ios'

    this.http.get(`${baseUrl}/checkVersioning?type=${type}&version=${version}`).subscribe((res) => {
      if (res['success'] == false) {
        this.platform.is('android') ? this.showUpdate('com.altomate.io') : this.showUpdate('id6449769620')
      } else {
        if (res['inAppVersion'] && res['inAppVersionUrl']) {
          this.inAppVersionData = { version: res['inAppVersion'], link: res['inAppVersionUrl'] }
          this.inAppVersion = res['inAppVersion']
          this.checkForUpdate()
        }
      }
    })
  }

  async checkForUpdate() {

    if (this.isNullOrEmpty(this.inAppVersionData['link']) || this.isNullOrEmpty(this.inAppVersionData['version'])) {
      return
    }

    let bundleList = await CapacitorUpdater.list()

    let foundBundle = bundleList.bundles.find(b => b['version'] == this.inAppVersionData['version'])
    let data: BundleInfo | null = null

    if (foundBundle == null) {

      if (this.inAppUpdateModal === null) {
        this.inAppUpdateModal = await this.modalCtrl.create({
          component: InappupdatePage,
          cssClass: 'updateModal',
          backdropDismiss: false,
          initialBreakpoint: 600 / this.platform.height(),
          componentProps: {
            // currentVersion: this.currentVersion,
            // latestVersion: this.currentVersion,
          }
        });

        this.inAppUpdateModal.present();
      }

      data = await CapacitorUpdater.download({
        url: this.inAppVersionData['link'],
        version: this.inAppVersionData['version']
      })
    }

    if (data || foundBundle['status'] == 'pending') {
      await new Promise(resolve => setTimeout(resolve, 2000))
      await CapacitorUpdater.set((data ? data : foundBundle))
    }
  }

  async showUpdate(marketid) {
    const modal = await this.modalCtrl.create({
      component: UpdatePage,
      cssClass: 'updateModal',
      backdropDismiss: false,
      initialBreakpoint: 600 / this.platform.height(),
      componentProps: {
        marketid: marketid,
        currentVersion: this.currentVersion,
        latestVersion: this.currentVersion,
      }
    });

    return await modal.present();
  }

  isAltomateLink() {
    let currentDomain = this.getDomain()
    // return currentDomain === 'altomate.io' || this.isNativePlatform();
    return currentDomain === 'web.app' || currentDomain === 'altomate.io' || currentDomain.includes('localhost') || this.isNativePlatform();
  }

  resetDefault() {
    this.loadingUser = true
    this.loadingCompanyList = true
    this.loadingTask = true
    this.loadingRequest = true
    this.loadingNotifications = true
    this.loadingTaskDetails = true
    this.loadingRequestDetails = true
    this.loadingInvoices = true
    this.loadingCompantDetails = true
    this.loadingResolutionDetails = true
    this.loadingResolutionList = true
    this.loadingDocuments = true
    this.loadingCosecDetails = true
    this.loadingTaskList = true
    this.isCompanylistExists = false
    this.isApplicationSubmitted = null
    this.loadingInvitations = false
  }

  toastMessages = {
    success: {
      icon: '✓'
    },
    error: {
      icon: '✕'
    },
    warning: {
      icon: '⚠'
    },
    info: {
      icon: 'i'
    },
    message: {
      icon: ''
    }
  };


  showToast(message, type, position) {
    console.log('show toast')
    const containerId = position === 'top' ? 'toastContainerTop' : 'toastContainerBottom';
    const container = document.getElementById(containerId);
    const toast = document.createElement('div');
    const toastData = this.toastMessages[type];
    const translatedMessage = typeof message === 'object' && message?.key
      ? this.translateService.translate(message.key, message.params || {})
      : this.translateService.translate(String(message ?? ''));

    toast.className = `custom-toast ${type}`;
    toast.innerHTML = `
        ${type === 'message' ? '' : `<div class="toast-icon">${toastData.icon}</div>`}
        <div class="toast-content">
            <div class="toast-message body-xs-medium">${translatedMessage}</div>
        </div>
        <button class="toast-close" onclick="closeToast(this)">×</button>
        <div class="toast-progress"></div>
    `;

    container.appendChild(toast);

    // Auto-remove after 4 seconds
    setTimeout(() => {
      this.closeToast(toast.querySelector('.toast-close'));
    }, 4000);
  }


  closeToast(button) {
    const toast = button.closest('.custom-toast');
    toast.classList.add('hiding');

    setTimeout(() => {
      toast.remove();
    }, 300);
  }

  replaceUndefinedWithEmptyString<T>(obj: T): T {
    if (Array.isArray(obj)) {
      return obj.map(this.replaceUndefinedWithEmptyString) as unknown as T;
    } else if (obj !== null && typeof obj === 'object') {
      const newObj: any = {};
      for (const key in obj) {
        const val = (obj as any)[key];

        console.log(val, key)
        newObj[key] = val === undefined || val === null ? '' : this.replaceUndefinedWithEmptyString(val);
      }
      return newObj;
    }
    return obj;
  }

  private formatNumber(value: any, decimalPlaces: number = 2): string {
    const num = parseFloat(value);
    if (isNaN(num)) {
      return '0.00'; // Or handle as an error, or return empty string
    }
    return num.toFixed(decimalPlaces);
  }

  private getSubtotal(currentInv: any): number {
    let total = 0;
    if (currentInv && currentInv.items) {
      for (const item of currentInv.items) {
        const amount = (item.quantity || 0) * (item.unit_price || 0) - item.discount || 0; // Assuming item.amount is pre-calculated
        total += amount;
      }
    }
    return parseFloat(total.toFixed(2));
  }

  private getTotal(currentInv: any): number {
    let total = 0;
    if (currentInv && currentInv.items) {
      for (const item of currentInv.items) {
        const amount = item.amount || 0; // Assuming item.amount is pre-calculated
        total += amount;
      }
    }
    total = parseFloat(total.toFixed(2));
    if (currentInv) {
      currentInv.totalAmount = total; // Mutating the passed inv object to store the calculated total
    }
    return total;
  }

  private getTotalTax(currentInv: any): number {
    let totalTax = 0;
    if (currentInv && currentInv.items) {
      for (const item of currentInv.items) {
        const unitPrice = item.unit_price || 0;
        const quantity = item.quantity || 0;
        const taxRate = (item.tax_rate || 0) / 100;
        totalTax += unitPrice * quantity * taxRate;
      }
    }
    totalTax = parseFloat(totalTax.toFixed(2));
    if (currentInv) {
      currentInv.totalTax = totalTax; // Mutating the passed inv object
    }
    return totalTax;
  }

  private getAmountDue(currentInv: any, currentPaymentsArray: any[] | null | undefined): number {
    let invoiceTotal = currentInv.totalAmount;

    // Ensure totalAmount is calculated if not already present
    if (typeof invoiceTotal !== 'number') {
      invoiceTotal = this.getTotal(currentInv);
    }

    let totalPaid = 0;
    if (currentPaymentsArray && currentPaymentsArray.length > 0) {
      currentPaymentsArray.forEach(p => {
        totalPaid += (p.amount || 0);
      });
    }
    // Optional: consider inv.amountPay if currentPaymentsArray is not the sole source of truth
    // else if (currentInv && typeof currentInv.amountPay === 'number') {
    //    totalPaid = currentInv.amountPay;
    // }


    const due = invoiceTotal - totalPaid;
    return parseFloat(due.toFixed(2));
  }

  // --- Main PDF Document Definition Method ---
  /** The public LHDN link for a validated document. Both halves are required. */
  buildMyInvoisShareUrl(uuid: string, longId: string): string | null {
    return uuid && longId ? `${myInvoisPortalUrl}/${uuid}/share/${longId}` : null;
  }

  /**
   * Resolves the shareable link for an outbound e-invoice, plus a QR code for it.
   *
   * Reuses the same MyInvois document endpoint the inbox already calls. longId is
   * not in the submit response - LHDN only mints it once validation finishes - so
   * this returns null while the document is still Submitted, and the caller renders
   * nothing rather than a QR that resolves to an unvalidated document.
   */
  async getMyInvoisShareLink(uuid: string, userTIN: string, attempts = 3): Promise<{ longId: string; url: string; qrDataUrl: string | null } | null> {
    if (!uuid || !userTIN) return null;
    try {
      const doc: any = await firstValueFrom(
        this.http.post<any>(`${einvoiceUrl}/document/${uuid}?userTIN=${encodeURIComponent(userTIN)}`, {})
      );
      const longId = doc?.longId || doc?.longID || '';
      const url = doc?.status === 'Valid' ? this.buildMyInvoisShareUrl(uuid, longId) : null;
      if (!url) {
        console.log(`MyInvois ${uuid}: no share link yet (status ${doc?.status || 'unknown'}, longId ${longId ? 'present' : 'missing'}).`);
        // Printing straight after approving usually lands while LHDN is still
        // validating. Give it a couple of short retries rather than sending the
        // user away with no QR on a document that is seconds from being Valid.
        // Anything already decided - Invalid, Cancelled - is final, so don't wait.
        const stillDeciding = !doc?.status || doc.status === 'Submitted' || doc.status === 'InProgress';
        if (stillDeciding && attempts > 1) {
          await new Promise(resolve => setTimeout(resolve, 1500));
          return this.getMyInvoisShareLink(uuid, userTIN, attempts - 1);
        }
        return null;
      }
      let qrDataUrl: string | null = null;
      try {
        qrDataUrl = await QRCode.toDataURL(url, { margin: 1, width: 200 });
      } catch (qrError) {
        console.error('MyInvois QR generation failed, link will render without it:', qrError);
      }
      return { longId, url, qrDataUrl };
    } catch (error) {
      console.error('Could not resolve MyInvois share link:', error);
      return null;
    }
  }

  async getDocumentDefinition(inv: any, theme: any, imgsrc: string | null | undefined, payment: any[] | null | undefined): Promise<any> {
    // The theme object is now passed directly. No need to load it here.
    // UI feedback like "pleaseWait" should be handled by the calling component.
    console.log('Active theme details in service:', theme);
    console.log('Invoice data in service:', inv);
    console.log('Image source in service:', imgsrc);
    console.log('Payment data in service:', payment);


    // --- Theme-dependent calculations and settings ---
    const ptToCm = (pt: number) => pt * 0.0352778;
    const cmToPt = (cm: number) => cm / 0.0352778;
    const inchesToPt = (inches: number) => inches * 72;

    // Fallback for theme if critical properties are missing
    const safeTheme = {
      topMargin: 1.5, bottomMargin: 1.5, addressPadding: 0.5, marginUnit: 'cm',
      fontSize: '10pt', font: 'Roboto', approvedInvoiceTitle: 'INVOICE',
      creditNoteTitle: 'CREDIT NOTE',
      billTitle: 'BILL',
      showLogo: true, showRegisteredAddress: true, contactDetails: 'Default Company Address',
      logoAlignment: 'Right', showUnitPriceAndQuantity: true, showTaxColumn: true, showColumnHeadings: true,

      termsAndPaymentAdvice: 'Thank you for your business.', termsQuotes: 'Quote valid for 30 days.',
      showPaymentAdviceCutAway: false, pageSize: 'A4',
      ...theme // Spread the provided theme, overriding defaults
    };


    let topMarginPt = safeTheme.topMargin;
    let bottomMarginPt = safeTheme.bottomMargin;
    let addressPaddingPt = safeTheme.addressPadding;

    if (safeTheme.marginUnit === 'cm') {
      topMarginPt = cmToPt(safeTheme.topMargin);
      bottomMarginPt = cmToPt(safeTheme.bottomMargin);
      addressPaddingPt = cmToPt(safeTheme.addressPadding);
    } else if (safeTheme.marginUnit === 'inches') {
      topMarginPt = inchesToPt(safeTheme.topMargin);
      bottomMarginPt = inchesToPt(safeTheme.bottomMargin);
      addressPaddingPt = inchesToPt(safeTheme.addressPadding);
    }
    const leftRightMarginPt = cmToPt(1.5); // Assuming fixed, or add to theme

    // --- Dynamic text based on invoice type and theme ---
    let documentTitleText = '';
    if (inv.type === 'Invoice') {
      // switch (inv.approval_status) {
      //   case 1: documentTitleText = safeTheme.draftInvoiceTitle; break;
      //   // case 2: documentTitleText = safeTheme.overdueInvoiceTitle; break;
      //   case 3: documentTitleText = safeTheme.approvedInvoiceTitle; break;
      //   default: documentTitleText = safeTheme.approvedInvoiceTitle;
      // }
      documentTitleText = inv.bank_payment == 'credit_note' ? 'CREDIT NOTE' : safeTheme.approvedInvoiceTitle;
    } else if (inv.type === 'Bill') {
      documentTitleText = inv.bank_payment == 'credit_note' ? 'CREDIT NOTE' : safeTheme.billTitle || "BILL";
    }
    // else if (inv.type === 'Quote') {
    //   documentTitleText = inv.status?.toUpperCase() === 'DRAFT' ? safeTheme.draftQuoteTitle : safeTheme.quoteTitle;
    // } else if (inv.type === 'PurchaseOrder') {
    //   documentTitleText = inv.status?.toUpperCase() === 'DRAFT' ? safeTheme.draftPurchaseOrderTitle : safeTheme.purchaseOrderTitle;
    // }

    const invoiceToFromText = inv.type === 'Invoice' ? 'To' : 'From';
    const invoiceBillNumberText = inv.type === 'Invoice' ? (inv.bank_payment == 'credit_note' ? 'Credit Note Number' : 'Invoice Number:') : (inv.bank_payment == 'credit_note' ? 'Credit Note Number' : 'Bill Number:');

    const content: any[] = [];

    // 1. Optional Logo & Company Registered Address
    if (safeTheme.showLogo || safeTheme.showRegisteredAddress) {
      const headerColumns: any[] = [];
      let companyDetailsBlock: any = null;

      if (safeTheme.showRegisteredAddress && safeTheme.contactDetails) {
        companyDetailsBlock = {
          text: safeTheme.contactDetails,
          style: 'companyAddress',
          margin: [0, 0, 0, addressPaddingPt]
        };
      }

      if (safeTheme.showLogo) {
        let logoContent: any;
        const logoPlaceholder = {
          svg: '<svg width="100" height="30" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="30" style="fill:rgb(200,200,200);" /><text x="50" y="20" font-family="sans-serif" font-size="10" text-anchor="middle" fill="black">LOGO</text></svg>',
          width: 100,
        };

        if (imgsrc) {
          const getBase64FromImageUrl = (imageUrl: string): Promise<string> => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = 'Anonymous'; // Standard casing
              img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                  reject(new Error('Could not get canvas context'));
                  return;
                }
                canvas.height = img.naturalHeight; // Use natural dimensions
                canvas.width = img.naturalWidth;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL(); // Defaults to PNG
                resolve(dataURL);
              };
              img.onerror = (error) => reject(error);
              img.src = imageUrl;
            });
          };

          try {
            // Ensure accountingUrl is defined and accessible.
            // If accountingUrl can be undefined/empty, handle it:
            const proxyUrl = accountingUrl ? `${accountingUrl}/image-proxy?url=${encodeURIComponent(imgsrc)}` : imgsrc;
            const base64Image = await getBase64FromImageUrl(proxyUrl);
            logoContent = { image: base64Image, width: 100 }; // Or dynamic width
          } catch (error) {
            console.error("Error loading image, using placeholder:", error);
            logoContent = logoPlaceholder;
          }
        } else {
          logoContent = logoPlaceholder;
        }

        if (safeTheme.logoAlignment === 'Left') {
          headerColumns.push({ stack: [logoContent, companyDetailsBlock].filter(Boolean), width: 'auto' });
          headerColumns.push({ text: '', width: '*' });
        } else if (safeTheme.logoAlignment === 'Right') {
          headerColumns.push({ text: '', width: '*' });
          headerColumns.push({ stack: [companyDetailsBlock, logoContent].filter(Boolean), width: 'auto', alignment: 'right' });
        } else { // Center
          headerColumns.push({ text: '', width: '*' });
          headerColumns.push({ stack: [logoContent, companyDetailsBlock].filter(Boolean), width: 'auto', alignment: 'center' });
          headerColumns.push({ text: '', width: '*' });
        }
        content.push({ columns: headerColumns, columnGap: 10, margin: [0, 0, 0, 20] });
      } else if (companyDetailsBlock) {
        content.push(companyDetailsBlock);
      }
    }

    // 2. Document Title
    content.push({ text: documentTitleText.toUpperCase(), style: 'header', alignment: 'right', margin: [0, 0, 0, 20] });
    //check invoice bill text should be credit note or not


    // 3. Invoice/Bill Info & To/From Info
    const invoiceInfoStack: any[] = [
      {
        text: `${invoiceBillNumberText} ${inv.bank_payment === 'credit_note' ? 'CR' : (inv.type === 'Invoice' ? 'INV-' : 'BIL-')}${inv.displayId || ''}`
      },
      { text: `Date: ${inv.invoiceDate ? new Date(inv.invoiceDate).toLocaleDateString() : ''}` },
      { text: `Due Date: ${inv.due_date ? new Date(inv.due_date).toLocaleDateString() : ''}` },
    ];
    if (inv.reference) invoiceInfoStack.push({ text: `Reference: ${inv.reference}` });
    invoiceInfoStack.push({ text: `Currency: ${inv.currency || ''}` });
    if (safeTheme.showTaxNumber && inv.your_company_tax_id) {
      invoiceInfoStack.push({ text: `Tax ID: ${inv.your_company_tax_id}`, margin: [0, 5, 0, 0] });
    }
    // if (safeTheme.showContactAccountNumber && inv.customer_account_number) {
    //   invoiceInfoStack.push({ text: `Account #: ${inv.customer_account_number}`, margin: [0, 5, 0, 0] });
    // }

    content.push({
      columns: [
        {
          stack: [
            { text: invoiceToFromText, style: 'subheader' },
            inv.company_name || '',
            inv.company_address_line1 || '',
            inv.company_address_line2 || '',
            inv.company_address_line3 || '',
            // ... other address fields
          ].filter(Boolean),
          width: '50%',
        },
        {
          stack: invoiceInfoStack,
          alignment: 'right',
          width: '50%',
        },
      ],
      margin: [0, 0, 0, 20],
    });

    // 4. Items Table
    const tableBody: any[][] = [];
    const tableHeaders: any[] = [];
    const tableWidths: any[] = [];

    tableHeaders.push({ text: '#', style: 'tableHeader' });
    tableWidths.push(5); // Fixed width for row number

    if (safeTheme.showItemCode && inv.items?.some((i: any) => i.item_code) && inv.bank_payment !== 'credit_note') {
      tableHeaders.push({ text: 'Item Code / Name', style: 'tableHeader' });
    } else if (inv.bank_payment === 'credit_note') {
      tableHeaders.push({ text: 'Item Description', style: 'tableHeader' });
    }
    else {
      tableHeaders.push({ text: 'Item Name', style: 'tableHeader' });
    }
    tableWidths.push('30%'); // Fixed percentage for item name/description - will wrap text

    // tableHeaders.push({ text: 'Account', style: 'tableHeader' }); // Assuming 'Name' is Account Name
    // tableWidths.push('*'); // Fixed width for account

    if (safeTheme.showUnitPriceAndQuantity) {
      tableHeaders.push({ text: 'Quantity', style: 'tableHeader', alignment: 'right' });
      tableWidths.push(35); // Fixed width for quantity
      tableHeaders.push({ text: 'Unit Price', style: 'tableHeader', alignment: 'right' });
      tableWidths.push(40); // Fixed width for unit price
      tableHeaders.push({ text: 'Discount', style: 'tableHeader', alignment: 'right' });
      tableWidths.push(35); // Fixed width for discount
    }

    if (safeTheme.showTaxColumn) {
      tableHeaders.push({ text: 'Tax Rate', style: 'tableHeader', alignment: 'right' });
      tableWidths.push(35); // Fixed width for tax rate
    }

    tableHeaders.push({ text: 'Amount', style: 'tableHeader', alignment: 'right' });
    tableWidths.push('*'); // Remaining space for amount

    if (safeTheme.showColumnHeadings) {
      tableBody.push(tableHeaders);
    }

    (inv.items || []).forEach((item: any, index: number) => {
      const row: any[] = [(index + 1).toString()];
      const itemStack: any[] = [];
      if (safeTheme.showItemCode && item.item_code) {
        itemStack.push({ text: `${item.item_code} - ${item.item_name || ''}` });
      } else if (inv.bank_payment === 'credit_note') {
        itemStack.push({ text: item.item_description || '' });
      } else {
        itemStack.push({ text: item.item_name || '' });
      }

      if (inv.bank_payment !== 'credit_note' && item.item_description) {
        itemStack.push({
          text: item.item_description,
          fontSize: 9,
          color: '#555555',
          margin: [0, 2, 0, 0]
        });
      }

      row.push({ stack: itemStack });
      // row.push(item.Name || ''); // Account Name from item.Name

      if (safeTheme.showUnitPriceAndQuantity) {
        row.push({ text: item.quantity || '', alignment: 'right' });
        row.push({ text: this.formatNumber(item.unit_price), alignment: 'right' });
        row.push({ text: this.formatNumber(item.discount), alignment: 'right' });
      }
      if (safeTheme.showTaxColumn) {
        row.push({ text: item.tax_rate ? this.formatNumber(item.tax_rate) + '%' : '0%', alignment: 'right' });
      }
      row.push({ text: this.formatNumber(item.amount), alignment: 'right' });
      tableBody.push(row);
    });

    if (tableBody.length > (safeTheme.showColumnHeadings ? 1 : 0)) { // Add table if items exist
      content.push({
        table: {
          headerRows: safeTheme.showColumnHeadings ? 1 : 0,
          widths: tableWidths,
          body: tableBody,
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 10],
      });
    }


    // 5. Totals Section
    const totalsStack: any[] = [];
    const documentCurrency = (inv.currency || 'MYR').toString().trim().toUpperCase();
    const formatDocumentCurrency = (value: number): string => `${documentCurrency} ${this.formatNumber(value)}`;
    // Ensure getTotal, getSubtotal, getTotalTax are called with 'inv'
    totalsStack.push({ text: `Total before discount: ${formatDocumentCurrency(inv.totalbeforediscount)}`, alignment: 'right' });
    totalsStack.push({ text: `Subtotal: ${formatDocumentCurrency(this.getSubtotal(inv))}`, alignment: 'right' });

    const totalTax = inv.totalTax; // Calculate once
    // if (safeTheme.showTaxesAs === 'Exclusive' && totalTax > 0) {
    // For simplicity, showing total tax if exclusive and > 0.
    // Theme's 'showSubtotalsBy' can add more complex logic here.
    totalsStack.push({ text: `Total Tax: ${formatDocumentCurrency(totalTax)}`, alignment: 'right' });
    // } 
    // else if (safeTheme.showTaxesAs === 'Inclusive' && totalTax > 0) {
    //   totalsStack.push({ text: `(Includes Tax: RM ${this.formatNumber(totalTax)})`, alignment: 'right', italics: true, fontSize: 9 });
    // }

    totalsStack.push({ text: `Invoice Total: ${formatDocumentCurrency(this.getTotal(inv))}`, style: 'boldTotal', alignment: 'right', margin: [0, 0, 0, 10] });

    if (inv.amountPay) { // This is a summary amount from inv object
      totalsStack.push({ text: `Total Payments: ${formatDocumentCurrency(inv.amountPay)}`, alignment: 'right' });
    }

    // Iterate the 'payment' array passed to the function
    (payment || []).forEach((pay: any) => {
      if (inv.bank_payment == null) {
        totalsStack.push({
          text: `Less: Payment (${pay.payment_date ? new Date(pay.payment_date).toLocaleDateString() : 'N/A'}): ${formatDocumentCurrency(pay.amount)}`,
          alignment: 'right',
        });
      } else if (inv.bank_payment != null && pay.account == null) {
        totalsStack.push({
          text: `Less: Credit to (${pay.type}): ${formatDocumentCurrency(pay.amount)}`,
          alignment: 'right',
        });
      } else if (inv.bank_payment != null && pay.account != null) {
        totalsStack.push({
          text: `Less: Refund (${new Date(pay.payment_date).toLocaleDateString()}): ${formatDocumentCurrency(pay.amount)}`,
          alignment: 'right',
        });
      }

    });
    // Ensure getAmountDue is called with 'inv' and 'payment'
    totalsStack.push({ text: `Amount Due: ${formatDocumentCurrency(this.getAmountDue(inv, payment))}`, style: 'boldTotal', alignment: 'right' });

    content.push({
      columns: [
        {},
        { stack: totalsStack.filter(Boolean), width: 'auto' },
      ],
      margin: [0, 0, 0, 20]
    });

    // 5b. Validated e-Invoice link. The caller resolves this via
    // getMyInvoisShareLink() and hangs it on `inv`, so an unvalidated or rejected
    // document simply renders nothing here.
    if (inv.myinvoisShareUrl) {
      const linkColumns: any[] = [];
      if (inv.myinvoisQrDataUrl) {
        linkColumns.push({ image: inv.myinvoisQrDataUrl, width: 78, margin: [0, 0, 12, 0] });
      }
      linkColumns.push({
        width: '*',
        stack: [
          { text: 'Validated e-Invoice', style: 'einvoiceHeader' },
          { text: 'Validated by LHDN MyInvois. Scan the code or open the link to view the official document.', style: 'einvoiceDetail' },
          { text: inv.myinvoisShareUrl, link: inv.myinvoisShareUrl, style: 'einvoiceLink' },
          { text: `UUID: ${inv.myinvois_uuid || ''}`, style: 'einvoiceDetail' },
        ].filter(Boolean)
      });

      content.push({
        columns: linkColumns,
        margin: [0, 0, 0, 16],
        unbreakable: true
      });
    }

    // 6. Terms & Payment Advice
    let termsText = '';
    if (['Invoice', 'Bill'].includes(inv.type)) {
      termsText = safeTheme.termsAndPaymentAdvice;
    }
    // else if (inv.type === 'Quote') {
    //   termsText = safeTheme.termsQuotes;
    // }
    if (termsText) {
      content.push({ text: termsText, style: 'terms', margin: [0, 0, 0, 10] });
    }

    // 7. Payment Advice Cut-Away
    if (safeTheme.showPaymentAdviceCutAway && ['Invoice'].includes(inv.type)) {
      content.push({
        canvas: [{ type: 'line', x1: 0, y1: 5, x2: cmToPt(18), y2: 5, dash: { length: 2, space: 2 }, lineColor: '#cccccc' }],
        margin: [0, 10, 0, 5]
      });
      content.push({
        text: 'Payment Advice - Please detach and return with your payment.',
        style: 'paymentAdviceHeader'
      });
      content.push({
        text: `Customer: ${inv.company_name || ''}\nInvoice #: ${(inv.type === 'Invoice' ? 'INV-' : 'BIL-') + (inv.displayId || '')}\nAmount Due: ${formatDocumentCurrency(this.getAmountDue(inv, payment))}`,
        style: 'paymentAdviceDetails'
      });
    }

    // --- PDF Document Definition ---
    const baseFontSize = parseInt((safeTheme.fontSize || '10pt').replace('pt', ''));
    const docNumber = (inv.type === 'Invoice' ? 'INV-' : 'BIL-') + (inv.displayId || '');

    return {
      info: {
        title: `${documentTitleText} - ${docNumber}`.trim(),
        author: inv.company_name || 'Altomate',
        subject: documentTitleText,
        creator: 'Altomate'
      },
      pageSize: safeTheme.pageSize === 'USLETTER' ? 'LETTER' : safeTheme.pageSize,
      pageMargins: [leftRightMarginPt, topMarginPt, leftRightMarginPt, bottomMarginPt],
      content: content.filter(Boolean),
      styles: {
        header: { fontSize: baseFontSize + 4, bold: true },
        subheader: { fontSize: baseFontSize, bold: true, margin: [0, 10, 0, 5] },
        companyAddress: { fontSize: baseFontSize - 1 },
        tableHeader: { bold: true, fontSize: baseFontSize - 1, fillColor: '#eeeeee' },
        boldTotal: { bold: true, fontSize: baseFontSize + 1 },
        terms: { fontSize: baseFontSize - 2, italics: true },
        paymentAdviceHeader: { fontSize: baseFontSize - 1, bold: true },
        paymentAdviceDetails: { fontSize: baseFontSize - 1 },
        einvoiceHeader: { fontSize: baseFontSize - 1, bold: true, margin: [0, 0, 0, 2] },
        einvoiceDetail: { fontSize: baseFontSize - 3, color: '#555555' },
        einvoiceLink: { fontSize: baseFontSize - 3, color: '#0e6e6b', margin: [0, 1, 0, 1] }
      },
      defaultStyle: {
        font: safeTheme.font,
        fontSize: baseFontSize,
        lineHeight: 1.2,
      },
      footer: function (currentPage: number, pageCount: number) {
        return {
          text: `Page ${currentPage.toString()} of ${pageCount.toString()}`,
          alignment: 'center',
          fontSize: baseFontSize - 2,
          margin: [0, 10, 0, 0]
        };
      }
    };
  }

  async pickFile() {

    return new Promise(async (resolve) => {

      try {
        const result = await FilePicker.pickFiles({
          types: ['image/*'],
          limit: 1,
          readData: true
        });

        const file: any = result.files[0];

        // The backend converts any image to PNG, except iPhone HEIC photos it can't read.
        if (/hei[cf]/i.test(file.mimeType || '') || /\.hei[cf]$/i.test(file.name || '')) {
          this.showToast('HEIC photos are not supported. Please choose a JPG or PNG image.', 'error', 'bottom');
          resolve({ success: false });
          return;
        }

        const byteString = atob(file.data);
        const mimeType = file.mimeType || 'application/octet-stream';
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([ab], { type: mimeType });
        const rawFile = new File([blob], file.name, { type: mimeType });


        resolve({ success: true, rawFile })

      } catch (error) {
        console.log(error)

        resolve({ success: false })
        // resolve(await this.pickFile())
      }

    })



    // if (result.accessMediaLocation === 'prompt') {
    //   let requestResult = await FilePicker.requestPermissions({
    //     permissions: ["accessMediaLocation"]
    //   });

    //   console.log(requestResult)
    // }

    // if (result.accessMediaLocation === 'granted' || result.readExternalStorage === 'granted') {



    // }

  }


  lengOfObject(obj) {
    return Object.keys(obj).length;
  }

  capitalizeFirst(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
